export default __webpack_public_path__ + "static/media/Group3378.be7420ff.svg";